
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/everworld/[permalink]",
      function () {
        return require("private-next-pages/everworld/[permalink].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/everworld/[permalink]"])
      });
    }
  